package team.platforma.materialextension.sample_screens

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import team.platforma.multiplatform_material_extension.text_input.TextInput

@Composable
fun PersonalDataSample() {

    var password by remember { mutableStateOf("") }

    Column {
        TextInput(
            value = password,
            onValueChange = {
                password = it
            },
            supportingText = if (password.isNotEmpty()) {
                { Text("не пусто") }
            } else null
        )

    }
}